// | ------------------------------------------------------------------------
// | Shave
// | ------------------------------------------------------------------------

//? https://github.com/yowainwright/shave
import shave from "shave"; // Used in /components/ellipsis

// | ------------------------------------------------------------------------


document.addEventListener("DOMContentLoaded", function () {

  var jobLink = document.querySelector(".job-link");

  if(jobLink){
    shave(".job-link p", 70, {});
  }


  //var projectItem = document.querySelector(".project-item");

  //if(projectItem){

  //  shave(".project-item-title", 78, {});

  //}

});

    
  


